(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["instagram-carousel-plus"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('flexible-instagram-carousel')) {
  customElements.define('flexible-instagram-carousel', class extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-track]');
      if (!this.track) return;
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
      const prev = this.querySelector('[data-prev]');
      const next = this.querySelector('[data-next]');
      const update = () => {
        const max = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
        const pos = Math.abs(this.track.scrollLeft);
        if (prev) prev.disabled = pos < 2;
        if (next) next.disabled = pos >= max - 2;
      };
      const move = direction => {
        const card = this.querySelector('[data-item]');
        if (!card) return;
        const step = card.getBoundingClientRect().width + parseFloat(getComputedStyle(this.track).columnGap || 0);
        const rtl = getComputedStyle(this.track).direction === 'rtl' ? -1 : 1;
        this.track.scrollBy({ left: direction * step * rtl, behavior: reducedMotion.matches ? 'auto' : 'smooth' });
      };
      prev?.addEventListener('click', () => move(-1), options);
      next?.addEventListener('click', () => move(1), options);
      this.track.addEventListener('scroll', update, { ...options, passive: true });
      let drag = null;
      let suppressClick = false;
      this.track.addEventListener('pointerdown', event => {
        if (event.pointerType !== 'mouse' || event.button !== 0 || event.target.closest('button')) return;
        suppressClick = false;
        drag = { x: event.clientX, left: this.track.scrollLeft, active: false };
      }, options);
      this.track.addEventListener('dragstart', event => event.preventDefault(), options);
      window.addEventListener('pointermove', event => {
        if (!drag) return;
        const delta = event.clientX - drag.x;
        if (Math.abs(delta) > 6) drag.active = true;
        if (!drag.active) return;
        event.preventDefault();
        suppressClick = true;
        this.track.style.scrollBehavior = 'auto';
        this.track.style.scrollSnapType = 'none';
        this.track.style.userSelect = 'none';
        this.track.scrollLeft = drag.left - delta;
      }, options);
      const stopDrag = () => {
        drag = null;
        this.track.style.removeProperty('scroll-behavior');
        this.track.style.removeProperty('scroll-snap-type');
        this.track.style.removeProperty('user-select');
      };
      window.addEventListener('pointerup', stopDrag, options);
      window.addEventListener('pointercancel', stopDrag, options);
      window.addEventListener('blur', stopDrag, options);
      this.track.addEventListener('click', event => {
        if (!suppressClick) return;
        event.preventDefault();
        event.stopPropagation();
        suppressClick = false;
      }, { ...options, capture: true });
      this.addEventListener('shopify:block:select', event => {
        const item = event.target.closest('[data-item]');
        if (!item || !this.contains(item)) return;
        const rect = item.getBoundingClientRect();
        const trackRect = this.track.getBoundingClientRect();
        this.track.scrollBy({ left: rect.left - trackRect.left - (trackRect.width - rect.width) / 2, behavior: 'auto' });
      }, options);
      this.resize = new ResizeObserver(update);
      this.resize.observe(this.track);
      this.querySelectorAll('[data-item]').forEach(item => this.resize.observe(item));
      const videos = [...this.querySelectorAll('video')];
      const play = video => { const result = video.play(); if (result) result.catch(() => {}); };
      this.visibility = new IntersectionObserver(entries => entries.forEach(entry => {
        const video = entry.target;
        video.dataset.visible = String(entry.isIntersecting);
        if (entry.isIntersecting && !document.hidden && !reducedMotion.matches && video.dataset.userPaused !== 'true') play(video);
        else video.pause();
      }), { threshold: 0.25 });
      videos.forEach(video => {
        const button = video.closest('[data-item]').querySelector('[data-video-toggle]');
        const sync = () => {
          button.setAttribute('aria-label', video.paused ? button.dataset.play : button.dataset.pause);
          button.querySelector('[data-play-icon]').hidden = !video.paused;
          button.querySelector('[data-pause-icon]').hidden = video.paused;
        };
        video.addEventListener('play', sync, options);
        video.addEventListener('pause', sync, options);
        button.addEventListener('click', () => {
          if (video.paused) { video.dataset.userPaused = 'false'; play(video); }
          else { video.dataset.userPaused = 'true'; video.pause(); }
        }, options);
        this.visibility.observe(video);
      });
      document.addEventListener('visibilitychange', () => videos.forEach(video => {
        if (document.hidden) video.pause();
        else if (video.dataset.visible === 'true' && video.dataset.userPaused !== 'true' && !reducedMotion.matches) play(video);
      }), options);
      update();
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.resize?.disconnect();
      this.visibility?.disconnect();
      this.querySelectorAll('video').forEach(video => video.pause());
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
